import React from "react";
import ButtonTemplate from "../Templates/ButtonTemplate";

const Export = (props) => {
  const eventName = props.data.exportEventName || props.additionalOptions.exportEventName
  const downloadUrl = props.data.downloadUrl || props.additionalOptions.downloadUrl
  const buildUrlWithFilters = props.additionalOptions?.buildUrlWithFilters

  const downloadFileFromUrl = (url) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = '';
    link.style.display = 'none';
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const clickHandler = (event) => {
    // If downloadUrl is provided, use direct download instead of custom event
    if (downloadUrl) {
      const urlWithFilters = buildUrlWithFilters ? buildUrlWithFilters(downloadUrl) : downloadUrl;
      downloadFileFromUrl(urlWithFilters);
    } else {
      const customEvent = new CustomEvent(eventName, { detail: { as: props.data.as }});
      document.dispatchEvent(customEvent);
    }
  }

  return(
    <ButtonTemplate {...props} onClick={ clickHandler } />
  )
}

export default Export;